import { render, staticRenderFns } from "./TicketGoods.vue?vue&type=template&id=703bf890&scoped=true"
import script from "./TicketGoods.vue?vue&type=script&lang=js"
export * from "./TicketGoods.vue?vue&type=script&lang=js"
import style0 from "./TicketGoods.vue?vue&type=style&index=0&id=703bf890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bf890",
  null
  
)

export default component.exports